import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getOpcoUsersPath = () => urlHelper('/opco-users');
